import React, { useEffect, useState } from 'react';
import { RoughNotation } from 'react-rough-notation';
import { StaticImage } from 'gatsby-plugin-image';
import { graphql } from 'gatsby';
import Cookies from 'js-cookie';
/* --- import Components ----*/
import { AnchorButton, Button, MobileApplyBTN } from 'src/components/Button';
import { BtnWrapper, HeroLeft } from 'src/components/Hero/elements';
import { Career, LearningAndTechno, Profile, QuestionCTA, WhyJS } from 'src/components/Bootcamp';
import { DiplomaSection, TASection } from '../components/Home';
import {
  HeaderDescription,
  HeaderTitle,
  Paragraph,
  SectionTitle,
  StyledLink,
} from 'src/components/Typography';
import { ProjectsExamples, ProjectsOverview } from 'src/components/Projects';
import { Section, TwoColumns } from '../components/Section';
import { AdmissionProcess } from 'src/components/Bootcamp/AdmissionTimeline';
import { AlumniJobGrid } from '../components/Bootcamp/Testimonials';
import { Apply } from '../components/Apply/index';
import { BestBootcamp } from 'src/components/Home';
import { CTASection } from '../components/CTA';
import { EventsSection } from '../components/MeetUs/index';
import { GoogleReviews } from 'src/components/GoogleReview';
import { HeaderBanner } from '../components/Section/index';
import Layout from '../components/Layout';
import ModalForm from 'src/components/Modal/ModalFormSyllabus';
import Opportunities from '../components/Bootcamp/Opportunities/Opportunities';
import { Schedule } from '../components/Bootcamp/Schedule/index';
import Tag from 'src/components/Tags/Tag';
import { TagContainer } from 'src/components/Tags/elements';
import { TopbarStaticSpace } from '../components/Topbar';
import TopbarWithSubBar from 'src/components/Topbar/TopbarWithSubBar';
import FeaturesSection from 'src/components/Bootcamp/FeaturesSection';
import TopBanner from 'src/components/TopBanner';
/* --- import Utils ----*/
import { nextSessionsFilter, SessionDateDisplay } from 'src/utils/helpers';
import { useUpcomingSessions } from 'src/utils/useUpcomingSessions';
/* --- import Styles ----*/
import { mediaQueries } from 'src/style/breakpoints';
import sizes from 'src/style/sizes';
import colors from 'src/style/colors';

//mport VisioSmall from 'src/components/Icons/VisioSmall';

/* --- import Logos ----*/

const courseType = 'Temps Plein';

const FullTimePage = ({ location }) => {
  const nextSessions = useUpcomingSessions();
  const [buttonVisible, setButtonVisible] = useState(false);
  const [sectionScrolled, setSectionScrolled] = useState(null);
  const [isModalFormOpen, setIsModalFormOpen] = useState(false);
  const [formSuccess, setFormSuccess] = useState(false);
  const [values, setValues] = useState();
  const [isBannerClosed, setIsBannerClose] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      if (global.window && window.pageYOffset >= 150) {
        return setButtonVisible(true);
      } else {
        return setButtonVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [buttonVisible]);

  const container = React.useRef();

  useEffect(() => {
    const isElementVisible = () => {
      const allContainer = Array.from(container.current.children);
      let current = null;

      for (let i = 0; i < allContainer.length; i++) {
        const oneContainer = allContainer[i];
        const itemPos = oneContainer.getBoundingClientRect();
        const isVisible = itemPos.top <= 260 && itemPos.bottom >= 240;
        if (isVisible) {
          current = oneContainer;
        }
      }

      const expectedValue = current ? '#' + current.id : null;
      if (sectionScrolled !== expectedValue) {
        setSectionScrolled(expectedValue);
      }
    };
    window.addEventListener('scroll', isElementVisible);
    return () => window.removeEventListener('scroll', isElementVisible);
  }, [sectionScrolled]);

  const nextFullTimeSession = nextSessionsFilter(nextSessions, 'Temps Plein');
  const date = SessionDateDisplay(nextFullTimeSession[0], courseType);

  useEffect(() => {
    if (!Cookies.get('bannerHidden')) {
      setIsBannerClose(false);
    }
  }, []);

  return (
    <Layout
      pathname={location.pathname}
      businessType="B2C"
      pageName="Bootcamp full-time"
      pageType="bootcamp"
      metaTitle="Formation Développeur Web & Mobile + IA | Le Reacteur"
      metaDescription="Apprenez à coder en rejoignant Le Reacteur, un coding bootcamp de 10 semaines, à distance (en visio) et devenez Développeur Web & Mobile."
      currentCoursePage={courseType}
      isBootcampPage={true}
    >
      {isBannerClosed ? null : <TopBanner setIsBannerClose={setIsBannerClose} />}

      <TopbarWithSubBar
        currentCoursePage={courseType}
        sectionScrolled={sectionScrolled}
        isBannerClosed={isBannerClosed}
      />

      <Section
        theme="primary"
        hero={true}
        css={{
          [mediaQueries.desktopUp]: {
            height: '100vh',
            minHeight: '820px',
            maxHeight: '1000px',
          },
        }}
      >
        <TopbarStaticSpace />
        <div
          css={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            [mediaQueries.desktopUp]: {
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: '-110px',
            },
          }}
        >
          <HeroLeft css={{ flex: 1 }} data-cy="heroLeft">
            <HeaderTitle>
              Formation Développeur{' '}
              <br
                css={{
                  display: 'none',
                  [mediaQueries.tabletPortraitUp]: {
                    display: 'block',
                  },
                  [mediaQueries.phoneOnly]: {
                    display: 'block',
                  },
                  // [mediaQueries.desktopUp]: {
                  //   display: 'none',
                  // },
                }}
              />
              Web & Mobile + IA{' '}
            </HeaderTitle>
            <div
              css={{
                display: 'block',
                [mediaQueries.phoneOnly]: {
                  display: 'none',
                },
              }}
            >
              <TagContainer>
                {/* <Tag hero color="purpleDark" spacer>
                  Web+Mobile
                </Tag> */}
                <Tag hero color="purpleDark" spacer>
                  web+mobile
                </Tag>
                <Tag color="yellow" hero spacer>
                  diplômant Bac+3/4
                </Tag>
                <Tag type="online" hero />
              </TagContainer>
            </div>
            <div
              css={{
                display: 'none',
                [mediaQueries.phoneOnly]: {
                  display: 'block',
                },
              }}
            >
              <TagContainer>
                <Tag hero color="purpleDark" spacer>
                  Web+Mobile
                </Tag>
                <Tag color="yellow" hero>
                  diplômant Bac+3/4
                </Tag>
              </TagContainer>
              <TagContainer>
                <Tag type="online" hero />
              </TagContainer>
            </div>
            <HeaderDescription
              css={{
                marginTop: 30,
                textAlign: 'center',
                [mediaQueries.desktopUp]: {
                  marginRight: 60,
                  textAlign: 'left',
                },
              }}
            >
              Un format à temps plein de 10 semaines intensives pour devenir{' '}
              <strong>Développeur Web et Mobile</strong>. Vous apprendrez à maîtriser les
              technologies les plus demandées et à{' '}
              <strong>décupler votre efficacité grâce à l'IA</strong>, le tout auprès de formateurs
              expérimentés.
            </HeaderDescription>
            <HeaderDescription
              css={{
                color: colors.yellow,
                fontWeight: 'bold',
                marginTop: 8,
              }}
            >
              Prochaine session :{' '}
              <br
                css={{
                  [mediaQueries.tabletPortraitUp]: {
                    display: 'none',
                  },
                }}
              />
              {date}
            </HeaderDescription>
            {/*  <Sentence
              css={{
                color: colors.yellow,
                marginTop: 2,
              }}
            >
              <VisioSmall css={{ marginRight: 8, marginBottom: '-10px' }} />
              Exceptionnellement À distance
            </Sentence> */}
            <BtnWrapper data-cy="apply-btn1">
              <AnchorButton
                className="apply-btn"
                to="/postuler"
                state={{
                  fromFormationsPage: {
                    certification: 'RNCP6',
                    type: courseType,
                    date: nextFullTimeSession[0]?.id ?? null,
                  },
                }}
                css={{
                  marginRight: 16,
                  [mediaQueries.phoneOnly]: {
                    marginRight: 0,
                    marginBottom: '20px',
                    width: '100%',
                  },
                }}
              >
                Postuler
              </AnchorButton>
              <Button
                secondary
                css={{
                  minWidth: 210,
                }}
                onClick={() => {
                  setIsModalFormOpen(!isModalFormOpen);
                }}
              >
                Recevoir{' '}
                <br
                  css={{
                    [mediaQueries.tabletPortraitUp]: {
                      display: 'none',
                    },
                  }}
                />{' '}
                le programme de formation
              </Button>
            </BtnWrapper>
            {isModalFormOpen && (
              <>
                <ModalForm
                  isOpen={isModalFormOpen}
                  onClose={() => {
                    setFormSuccess(false);
                    setIsModalFormOpen(false);
                  }}
                  fromFormationsPageType={courseType}
                  formSuccess={formSuccess}
                  setFormSuccess={setFormSuccess}
                  values={values}
                  setValues={setValues}
                />
              </>
            )}
          </HeroLeft>
          <StaticImage
            src="../../src/data/images/2023_students2.jpg"
            alt="Formation Développeur Web & Mobile + IA : des élèves au Reacteur"
            css={{
              display: 'flex',
              flex: 1,
              [mediaQueries.phoneOnly]: {
                marginTop: 40,
              },
              [mediaQueries.tabletPortraitUp]: {
                marginTop: 100,
              },
              [mediaQueries.tabletLandscapeUp]: {
                marginTop: 100,
              },
              [mediaQueries.desktopUp]: {
                marginTop: '0',
              },
            }}
            imgStyle={{
              borderRadius: 5,
              boxShadow: '5px 25px 40px rgba(0, 0, 0, 0.2)',
              objectFit: 'cover',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
            }}
          />
        </div>
      </Section>
      <HeaderBanner theme="secondary">
        <Profile defaultIndex={1} fromFormationsPageType={courseType} />
      </HeaderBanner>

      {/* UN CODING BOOTCAMP */}
      <Section theme="secondary">
        <div css={{ paddingBottom: 0 }}>
          <TwoColumns
            center
            reverse
            sizeLeft={sizes.columnWidth.medium}
            right={
              <div css={{ flex: 1 }}>
                <SectionTitle>Un Coding Bootcamp ?</SectionTitle>
                <Paragraph
                  css={{
                    paddingTop: 30,
                    [mediaQueries.tabletPortraitUp]: {
                      paddingBottom: 0,
                    },
                  }}
                >
                  Que vous soyez actuellement&nbsp;salarié·e ou en{' '}
                  <StyledLink to="/blog/2020-01-27-reconversion-professionnelle-tout-quitter-pour-devenir-developpeur/">
                    reconversion professionnelle
                  </StyledLink>
                  , nous avons décliné notre bootcamp à temps plein ou en alternance.
                  <br />
                  <br />
                  <StyledLink to="/bootcamp-javascript/concepteur-developpeur-applications-temps-plein/">
                    À temps plein
                  </StyledLink>{' '}
                  pendant 10 semaines ou{' '}
                  <StyledLink to="/formation-alternance/concepteur-developpeur-applications-full-stack-javascript/">
                    en alternance
                  </StyledLink>{' '}
                  pendant 18 mois, vous pouvez désormais vous reconvertir professionnellement selon
                  vos disponibilités.
                  <br />
                  <br />
                  Le bootcamp à temps plein est dispensé <strong>à distance</strong> (en visio),
                  pour s'adapter à la localisation et/ou aux contraintes de mobilité (handicap, par
                  ex.) de tous nos élèves.
                  <br />
                  <br />

                  Si vous souhaitez en savoir plus sur notre bootcamp, n'hésitez pas à visionner
                  notre{' '}
                  <StyledLink to="/reunion-d-information/">
                    réunion d'information en vidéo
                  </StyledLink>
                  .
                </Paragraph>
              </div>
            }
            sizeRight={sizes.columnWidth.medium}
            left={
              <StaticImage
                src="../../src/data/images/2023_studentsAndTeacher2.jpg"
                alt="Formation Développeur Web & Mobile + IA : des élèves"
                // placeholder="none"
                css={{
                  flex: 1,
                  width: '100%',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                  borderRadius: 5,
                  boxShadow: '5px 25px 40px rgba(0, 0, 0, 0.2)',
                  [mediaQueries.phoneOnly]: {
                    height: '70%',
                    marginBottom: 15,
                  },
                  [mediaQueries.tabletPortraitUp]: {
                    height: '70%',
                  },
                  [mediaQueries.tabletLandscapeUp]: {
                    height: '100%',
                  },
                }}
              />
            }
          />
        </div>
      </Section>
      <BestBootcamp />
      <ProjectsOverview
        isModalFormOpen={isModalFormOpen}
        setIsModalFormOpen={setIsModalFormOpen}
        courseType={courseType}
        formSuccess={formSuccess}
        setFormSuccess={setFormSuccess}
        values={values}
        setValues={setValues}
        hideStudentsWork={true}
      />

      <DiplomaSection diploma="rncp6" />
      <ProjectsExamples theme="secondary" id="projets" />
      <LearningAndTechno id="objectives" title="Objectifs de la formation" />

      {/* ICONS SECTION */}
      <FeaturesSection fromPage="rncp6-fullTime" />
      <div ref={container}>
        <Apply
          nextSessions={nextFullTimeSession}
          id="next-sessions"
          fromFormationsPageType={courseType}
        />
        <Schedule
          course={'rncp6-fullTime'}
          isModalFormOpen={isModalFormOpen}
          setIsModalFormOpen={setIsModalFormOpen}
          courseType={courseType}
          formSuccess={formSuccess}
          setFormSuccess={setFormSuccess}
          values={values}
          setValues={setValues}
        >
          Pendant 10 semaines vous apprendrez la programmation à travers{' '}
          <span css={{ position: 'relative' }}>
            <RoughNotation
              type="underline"
              multiline={true}
              strokeWidth={2}
              color={colors.yellow}
              show={true}
              padding={[0, 0, 4, 0]}
            >
              7 modules
            </RoughNotation>
          </span>
          . L'apprentissage est progressif : chaque module est un prérequis pour le suivant.
          <br />
          <br />
          La matinée est dédiée à la correction des exercices de la veille ainsi qu'au cours du
          jour. Le reste de la journée, vous travaillerez sur des exercices pratiques, pour
          assimiler les nouvelles notions.
          <br />
          <br />
          Les deux dernières semaines de la formation sont dédiées aux projets. Vous réaliserez,
          pendant cette période, un site Web ou une application Mobile en utilisant{' '}
          <span css={{ position: 'relative' }}>
            <RoughNotation
              type="underline"
              multiline={true}
              strokeWidth={2}
              color={colors.yellow}
              show={true}
              padding={[0, 0, 4, 0]}
            >
              des outils d’intelligence artificielle
            </RoughNotation>
          </span>
          .
          <br />
          <br />
          Tom, Lucas, Gwendoline et Alexis vous formeront et vous soutiendront pendant toute cette
          période.
        </Schedule>
        <TASection />
        <WhyJS />
        <Career courseType={courseType} training="fullAndPartTime" />
        <AlumniJobGrid />
        <Opportunities />
        <GoogleReviews course="formation-developpeur-web-mobile" />
        <AdmissionProcess
          id="admission"
          fromFormationsPage={{
            certification: 'RNCP6',
            type: courseType,
            date: nextFullTimeSession[0]?.id ?? null,
          }}
        />
        <EventsSection id="event-section" />
      </div>

      <CTASection
        onBoardingPromise="10 semaines de code"
        course="Développeur Web & Mobile + IA"
        nextSession={date}
        nextFullTimeSession={nextFullTimeSession[0]?.id ?? null}
        numberOfWeeks="10"
        format="à&nbsp;temps plein"
        fromFormationsPageCertification="RNCP6"
        fromFormationsPageType={courseType}
        formSuccess={formSuccess}
        setFormSuccess={setFormSuccess}
        values={values}
        setValues={setValues}
      />
      <QuestionCTA bootcampLayout fromFormationsPage={courseType} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Course',
            name: `Formation Développeur Web & Mobile + IA, à temps plein`,
            description: `Apprenez à coder en rejoignant Le Reacteur, un coding bootcamp de 10 semaines, à distance (en visio) et devenez Développeur Web & Mobile.`,
            provider: {
              name: 'Le Reacteur',
              sameAs: [
                'https://www.lereacteur.io/bootcamp-javascript/concepteur-developpeur-applications-temps-plein/',
              ],
            },
          }),
        }}
      />
      <MobileApplyBTN
        data-cy="mobileApplyBtn"
        buttonVisible={buttonVisible}
        currentCoursePage={courseType}
        certification="RNCP6"
      />
    </Layout>
  );
};

export default FullTimePage;

export const query = graphql`
  query {
    allFile(filter: { extension: { eq: "pdf" } }) {
      edges {
        node {
          name
          publicURL
        }
      }
    }
  }
`;
